import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export default function SearchButton({onToggleSearch}: {onToggleSearch: () => void}): JSX.Element {
  return (
    <Button
      buttonStyle={ButtonStyle.TERTIARY_GRAY}
      size={ButtonSize.MINI}
      icon="search"
      onClick={onToggleSearch}
    />
  );
}
